import './component.scss'
import $ from 'jquery'

$(function () {
  let headerHeight = 0
  const positionArray = []

  function calculateNavigationPosition () {
    // ナビゲーションヘッダーの分だけ調整する
    const navigationHeader = $('.navigation-header')
    headerHeight = navigationHeader.outerHeight() + 20

    // ナビゲーションのリンクに紐づく項目を指定する
    const navigatedTargetArray = $('[id*=\'navigation-header-\']')
    for (let i = 0; i < navigatedTargetArray.length; i++) {
      const navigatedTarget = $(navigatedTargetArray[i])
      const targetTop = navigatedTarget.offset().top - headerHeight - 1
      const targetBottom = targetTop + navigatedTarget.outerHeight() - 1
      positionArray[i] = [targetTop, targetBottom]
    }
  }

  function updateCurrentPosition () {
    // 対象となるナビゲーションヘッダーを指定する
    const navigationHeaderLinks = $('.navigation-header__button')
    const currentClassName = 'navigation-header__button--current'
    const windowScrollTop = $(window).scrollTop()
    for (let i = 0; i < positionArray.length; i++) {
      // 現在のスクロール位置が、配列に格納した開始位置と終了位置の間にある場合
      if (positionArray[i][0] <= windowScrollTop && positionArray[i][1] >= windowScrollTop) {
        navigationHeaderLinks.removeClass(currentClassName)
        navigationHeaderLinks.eq(i).addClass(currentClassName)
      }
    }
  }

  // アコーディオンのボタンが押されたら長さが変わるので更新する
  $('.company-card-list__accordion--button').click(function () {
    // NOTE: アコーディオンが開くアニメーションの時間を待ってから更新する(0の場合は1以上にする必要がある)
    setTimeout(function () {
      calculateNavigationPosition()
    }, 400)
  })

  // 画面サイズが変わるとセクションの位置も変わるので再度取得する
  $(window).on('load resize', function () {
    calculateNavigationPosition()
  })

  // ページ読み込み時とスクロール時に、現在地をチェックする
  $(window).on('load scroll', function () {
    updateCurrentPosition()
  })

  // ヘッダの高さ分、ジャンプ位置をずらす
  $('a[href^=\'#navigation-header-\']').click(function () {
    const href = $(this).attr('href')
    const targetTop = $(href).offset().top - headerHeight
    $('html, body').animate({ scrollTop: targetTop }, 500, 'swing')

    // URLにアンカーリンクをつけない
    return false
  })
})
